<template>
  <div class="rewards">
    <Header />
    <div class="rewards-main">
      <div class="rewards-main-left">
        <div class="boxs-title">Reward Type</div>
        <div class="boxs">
          <div
            :class="[
              'boxs-item',
              {
                'boxs-item-active': index === rewardTypeIndex,
              },
            ]"
            v-for="(item, index) in rewardTypeList"
            :key="index"
            @click="rewardTypeIndex = index"
          >
            {{ item }}
          </div>
        </div>
        <div class="boxs-Cost">Cost</div>
        <div class="boxs">
          <div class="cost-item" v-for="(item, index) in costList" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="boxs-redeemable">
          <div>Your have <span>$ 1</span> Redeemable</div>
          <div class="agree">
            <div
              :class="checked ? 'box bgcolor' : 'box'"
              @click="checked = !checked"
            >
              <img
                v-if="checked"
                class="check"
                src="@/assets/pcImg/check.png"
                alt=""
              />
            </div>
            <div class="afford">Show cards I can afford</div>
          </div>
        </div>
      </div>
      <div class="rewards-main-right">
        <div class="search">
          <input type="text" placeholder="Search Rewards" />
          <img src="@/assets/pcImg/other/search.png" alt="图片" />
        </div>
        <div class="cards">
          <div class="card" @click="skip('/rewards/paypal')">
            <img
              class="card-img-top"
              src="@/assets/pcImg/paypal.png"
              alt="图片"
            />
            <div class="card-title">Paypal</div>
            <div class="arrowhead">
              <img src="@/assets/pcImg/other/arrowhead-right.png" alt="图片" />
            </div>
          </div>
          <div class="card" @click="skip('/rewards/walmart')">
            <img
              class="card-img-top"
              src="@/assets/pcImg/walmart.png"
              alt="图片"
            />
            <div class="card-title">Walmart</div>
            <div class="arrowhead">
              <img src="@/assets/pcImg/other/arrowhead-right.png" alt="图片" />
            </div>
          </div>
          <div class="card" @click="skip('/rewards/amazon')">
            <img
              class="card-img-top"
              src="@/assets/pcImg/amazon.png"
              alt="图片"
            />
            <div class="card-title">Amazon</div>
            <div class="arrowhead">
              <img src="@/assets/pcImg/other/arrowhead-right.png" alt="图片" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
export default {
  components: { Header, Footer },
  data() {
    return {
      rewardTypeList: ["eGift", "Other"],
      rewardTypeIndex: 0,
      costList: ["$10.5 Or Less", "$10.5 - $20", "20 Or More"],
      radio: "",
      checked: false,
    };
  },
  methods: {
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
  },
};
</script>
<style scoped>
.rewards {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.rewards-main {
  display: flex;
  width: calc(100% - 175px);
  padding: 20px 87.5px;
}
.rewards-main-left .boxs-title {
  font-size: 10px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 20px;
}
.rewards-main-left .boxs-Cost {
  font-size: 10px;
  font-weight: bold;
  margin-top: 10px;
}
.boxs-redeemable {
  font-size: 7.5px;
  margin-top: 30px;
  padding: 5px;

  background: #e9effd;
  border-radius: 1.25px;
  text-align: center;
}
.agree {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-size: 8.75px;
  margin-top: 15px;
  margin-bottom: 5px;
}
.agree > .box {
  width: 9.375px;
  height: 9.375px;
  background-color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.625px solid #999;
}
.agree > .bgcolor {
  background-color: #2e67ea;
  border: 0.625px solid #2e67ea;
}
.check {
  width: 5px;
  height: 5px;
}
.agree > .afford {
  font-size: 7.5px;
}
.boxs-redeemable span {
  font-weight: bold;
  font-size: 10px;
}
.boxs {
  display: flex;
  flex-direction: column;
  font-size: 10px;
}
.boxs-item {
  width: 63.75px;
  height: 25px;
  line-height: 25px;
  padding-left: 10px;
  cursor: pointer;
  text-align: left;
}
.boxs-item-active {
  background: rgba(46, 103, 234, 0.1);
  color: #2e67ea;
}
.cost-item {
  font-size: 10px;
  margin-top: 10px;
  padding-left: 8.75px;
}
.rewards-main-left {
  width: 150px;
}

/* 右侧 */
.rewards-main-right {
  width: 100%;
}
.search {
  float: right;
  position: relative;
}
.search > input {
  border: 0.625px solid #dddddd;
  border-radius: 2.5px;
  height: 23.75px;
  width: 133.125px;
  line-height: 23.75px;
  padding-left: 10px;
  padding-right: 20px;
  font-size: 8.75px;
  color: #232323;
}
.search > img {
  width: 15px;
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
}
.cards {
  display: flex;
  justify-content: space-around;
  margin-top: 50px;
}
.card {
  width: 122.5px;
  /* height: 158.75px; */
  padding: 7.5px;
  background: #ffffff;
  box-shadow: 0px 1.25px 6.25px 0.625px rgba(0, 0, 0, 0.1);
  border-radius: 2.5;
  cursor: pointer;
}
.card-img-top {
  width: 100%;
  height: auto;
}
.card-title {
  font-size: 10px;
  font-weight: bold;
  margin-top: 11px;
}
.arrowhead {
  margin-top: 30px;
  width: 100%;
}
.arrowhead img {
  float: right;
  width: 15px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/rewards.vue